import React from "react";

type StaticDialogueProps = {
  topHeading: string;
  children: string | React.ReactElement;
};

const StaticDialogue = ({ topHeading, children }: StaticDialogueProps) => {
  return (
    <div className={"flex flex-col"}>
      <p className={"mb-[10px] text-[14px] leading-[130%] text-mono-40"}>
        {topHeading}
      </p>
      <p className={"text-black-rock text-[18px] italic leading-[130%]"}>
        {children}
      </p>
    </div>
  );
};

export default StaticDialogue;
